'use client';

import React, { useEffect } from 'react';
import { useLayout } from '@/contexts/LayoutContext';

interface PageLayoutProps {
    children: React.ReactNode;
    pageContent?: Record<string, any> | null;
    showHeader?: boolean;
    showFooter?: boolean;
}

export const PageLayout = ({
    children,
    pageContent,
}: PageLayoutProps) => {
    const { setLayoutSettings } = useLayout();
    
    useEffect(() => {
        // Update layout settings based on page content or props
        const shouldShowHeader = !!pageContent?.showHeader;
        const shouldShowFooter = !!pageContent?.showFooter;
        const shouldShowNewsletter = !!pageContent?.showNewsLetter;
       
        setLayoutSettings({
            showHeader: shouldShowHeader,
            showFooter: shouldShowFooter,
            showNewsletter: shouldShowNewsletter,
        });
    }, [pageContent, setLayoutSettings]);

    return (
        <>
            {children}
        </>
    );
};
